<template>
  <v-container class="px-0 py-1 theme-selector">
    <v-subheader>{{ lang.config.themes.list.title }}</v-subheader>
    <v-row class="pa-0">
      <v-col
        v-for="(theme, i) in lang.config.themes.list.generic_list"
        :key="i"
        class="d-flex child-flex"
        cols="6"
      >
        <v-hover v-slot="{ hover }">
          <v-img
            :src="require('../../../../themes/' + theme.path + '/thumb.png')"
            :lazy-src="require('../../../../themes/' + theme.path + '/thumb.png')"
            aspect-ratio="1.77"
            class="grey lighten-2"
            :class="{ 'selected-theme': (lang.config.themes.info.generic_theme.path === theme.path) }"
          >
          <v-expand-transition>
            <div
              v-if="hover"
              class="theme-desc transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text"
              style="height: 100%;"
            >
              <p class="theme-name">{{ theme.name }}</p>
              <p class="theme-developer">
                <a
                  :href="theme.website"
                  target="_blank"
                >
                  {{ theme.developer }}
                </a>
              </p>
            </div>
          </v-expand-transition>
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  data: () => ({
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    select: null,
    items: [
      'Item 1',
      'Item 2',
      'Item 3',
      'Item 4'
    ],
    checkbox: false
  }),

  methods: {
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  }
}
</script>
